import React from 'react'
import { useValues } from 'kea'

import Price from '../sections/price'
import Flags from '../sections/flags'
import SearchWithin from '../sections/search-within'
import LanguageFilters from '../sections/teacher-speak'

import filtersLogic from '~/scenes/search/filters-page/logic'

export default function AllFilters () {
  const { isPriceFilterVisible, isLanguageFilterVisible, showTeacherSpeaksFilter } = useValues(filtersLogic)

  return (
    <div className='all-filters-content'>
      {!isLanguageFilterVisible && showTeacherSpeaksFilter && <LanguageFilters />}

      {!isPriceFilterVisible && <Price />}
      <Flags />
      <SearchWithin />
    </div>
  )
}
